<ng-container *ngIf='!accessDenied'>
    <div *ngIf='!loader' class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">DATA ENGINE</h5>
                <div style="flex-grow: 1;"></div>
                <!-- <button id="add" (click)="addNewDataEngine()" class="btn btn-primary float-right mr-3"> Add Data Engine
                </button> -->
                <div class="btn-group" ngbDropdown role="group" aria-label="Button group with nested dropdown">
                    <button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle> Add Data Engine</button>
                    <div class="dropdown-menu" ngbDropdownMenu>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('DRILL')">DRILL</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('PRESTO')">PRESTO</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('SSAS')">SSAS</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('KYLIN')">KYLIN</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('DRUID')">DRUID</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('OLAP')">OLAP</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('IMPALA')">IMPALA</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('SPARK')">SPARK</a>
                        <a class="dropdown-item primary" (click)="addNewDataEngine('CLICK_HOUSE')">Clickhouse</a>

                    </div>
                </div>
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100"
                           placeholder="Keywords" type="text" ng-reflect-maxlength="100" ng-reflect-model=""
                           [(ngModel)]="dataEngineReg">
                    <div>
                        <button id="Search" (click)="searchPDataEngine()" class="btn btn-primary float-left">Search
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3" *ngIf='dataEngineList && dataEngineList.length'>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Code </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Server">
                        <h6 class="mb-lg-0 medium text-truncate"> Server </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Port">
                        <h6 class="mb-lg-0 medium text-truncate"> Port </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="Type">
                        <h6 class="mb-lg-0 medium text-truncate"> Type </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Username">
                        <h6 class="mb-lg-0 medium text-truncate"> Username </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let de of dataEngineList;">

                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="{{de.dataEngineCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.dataEngineCode}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{de.name}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.name}} </h6>
                </div>
                <div *ngIf="de.type != 'DRILL'" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     ngbTooltip="{{de.server}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.server}} </h6>
                </div>
                <div *ngIf="de.type == 'DRILL'" class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                     ngbTooltip="{{de.customParameter2 ? de.customParameter2 : de.server}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.customParameter2 ? de.customParameter2 : de.server}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="{{de.port}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.port}} </h6>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="{{de.type}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.type}} </h6>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="{{de.username}}">
                    <h6 class="mb-lg-0 text-truncate"> {{de.username}} </h6>
                </div>
                <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center">
                    <h6 class="mb-lg-0" ngbtooltip="Click for more options" ng-reflect-ngb-tooltip="Click for more options">
                        <i class="fa fa-ellipsis-h" [id]="de.id" (click)=entityOps($event)></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="selectedEngineId==de.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(de)">
                                <i class="fa fa-pencil mr-2"> </i>Edit
                            </li>
                            <li (click)="removeEngine(de)">
                                <i class="fa fa-trash mr-2"> </i>Delete
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left text-center" [id]="de.id"
                     (mouseenter)=entityOps($event)
                     (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedEngineId==de.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="clickEdit(de)">
                                <i class="fa fa-pencil mr-2"> </i>Edit
                            </li>
                            <li (click)="removeEngine(de)">
                                <i class="fa fa-trash mr-2"> </i>Delete
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <ng-container *ngIf='dataEngineList.length == 0'>
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>

            <!-- PAGINATION -->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage}} - {{endingPage}} of {{totalEngines}}
                    items </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='dataEngineList && dataEngineList.length' [collectionSize]="totalEngines"
                                [rotate]="true" [maxSize]="5" [pageSize]="pageSize" [ellipses]="false"
                                [boundaryLinks]="true"
                                [(page)]="currentPage" (pageChange)="onPageChange($event)"
                                class="float-right"></ngb-pagination>
            </div>
        </div>
        <!-- ADDING OR UPDATING DATA ENGINE -->
        <div class="w-100 float-left" *ngIf='dataEnginePage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="!isEdit">Add Data Engine </h5>
                <h5 class="medium m-0" *ngIf="isEdit">Edit Data Engine - {{dataEngineData.dataEngineCode}}</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>

            </div>
            <div class="w-100 float-left mt-3">
                <div class='col-lg-6 col-md-6 float-left left-clear'>
                    <div class="form-group">
                        <label> Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataEngineData.name"
                               name="name"/>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 float-left'>
                    <div class="form-group">
                        <label>Type</label>
                        <input readonly type="text" class="form-control" [(ngModel)]="dataEngineData.type"
                               name="engineType"/>
                        <!-- <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataEngineData.type" name="type" /> -->
                        <!-- <select class="form-control light-bg" (change)='onSelectEngineType($event)'>
                            <option [value]="None">None</option>
                            <option *ngFor="let engine of engineOptions" [value]='engine' [selected]="dataEngineData.type == engine?true:null">{{engine}}</option>
                        </select> -->
                    </div>
                </div>
                <ng-container *ngIf="dataEngineData.type != 'DRILL'">
                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                        <div class="form-group">
                            <label>Server
                                <span class="text-danger medium">*</span>
                            </label>
                            <input maxlength="200" type="text" class="form-control" [(ngModel)]="dataEngineData.server"
                                   name="server"/>
                        </div>
                    </div>
                    <div class='col-lg-6 col-md-6 float-left'>
                        <div class="form-group">
                            <label>Port
                                <span class="text-danger medium">*</span>
                            </label>
                            <input maxlength="5" type="number" class="form-control" [(ngModel)]="dataEngineData.port"
                                   name="port"
                                   max="65535"/>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="dataEngineData.type == 'DRILL'">
                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                        <div class="form-group">
                            <label>Drill IP
                                <span class="text-danger medium">*</span>
                            </label>
                            <input maxlength="200" type="text" class="form-control"
                                   [(ngModel)]="dataEngineData.customParameter2" name="server" required/>
                        </div>
                    </div>
                    <div class='col-lg-6 col-md-6 float-left'>
                        <div class="form-group">
                            <label>Port
                                <span class="text-danger medium">*</span>
                            </label>
                            <input maxlength="5" type="number" class="form-control" [(ngModel)]="dataEngineData.port"
                                   name="port"
                                   max="65535"/>
                        </div>
                    </div>
                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                        <div class="form-group">
                            <label>Cluster ID</label>
                            <input maxlength="200" type="text" class="form-control"
                                   [(ngModel)]="dataEngineData.customParameter1" name="port"/>
                        </div>
                    </div>
                    <ng-container *ngFor="let cluster of clusterList; index as ind">
                        <div class='col-lg-6 col-md-6 float-left left-clear'>
                            <div class="col-6 float-left left-clear">
                                <div class="form-group">
                                    <label>Server {{ind+1}}
                                        <span class="text-danger medium">*</span>
                                    </label>
                                    <input maxlength="200" type="text" class="form-control" [(ngModel)]="cluster.ip"
                                           name="server" required/>
                                </div>
                            </div>
                            <div class='col-4 float-left'>
                                <div class="form-group">
                                    <label>Port {{ind+1}}</label>
                                    <input maxlength="5" type="number" class="form-control" [(ngModel)]="cluster.port"
                                           name="port"
                                           max="65535"/>
                                </div>
                            </div>
                            <div class='col-2 float-left'>
                                <div class="form-group">
                                    <i class="fa fa-times" (click)="removeCluster(ind)"></i>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <button class="btn btn-primary float-left" (click)="addCluster()">
                        Add Cluster
                    </button>
                </ng-container>
                <ng-container *ngIf="dataEngineData.type == 'SSAS'">
                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                        <div class="float-left">
                            <div class="align-v-center w-100 pt-3">
                                <div class="checkbox checkbox-primary">
                                    <input id="isWinAuth" type="checkbox"
                                           [(ngModel)]="dataEngineData.customParameter1"
                                           (change)="enableWinAuthAction($event)" checked>
                                    <label for="isWinAuth" class="mb-md-0"></label>
                                </div>
                                <label class="ml-2">Enable Windows Authentication</label>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!(dataEngineData.type == 'SSAS' && dataEngineData.customParameter1)">
                    <div class='col-lg-6 col-md-6 float-left left-clear'>
                        <div class="form-group">
                            <label> Username
                                <span class="text-danger medium">*</span>
                            </label>
                            <input maxlength="200" type="text" class="form-control"
                                   [(ngModel)]="dataEngineData.username"
                                   name="username"/>
                        </div>
                    </div>
                    <div class='col-lg-6 col-md-6 float-left'>
                        <div class="form-group">
                            <label> Password
                                <span class="text-danger medium">*</span>
                            </label>
                            <input maxlength="200" type="password" class="form-control"
                                   [(ngModel)]="dataEngineData.newPassword"
                                   name="password"/>
                        </div>
                    </div>
                </ng-container>
                <div class="col-lg-2 col-md-2 float-right">
                    <button class="btn btn-primary float-right" [disabled]="saveButton" (click)="onSave()">Save</button>
                </div>
            </div>
        </div>
    </div>
    <div class="w-100 float-left min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dataEngine.component.html